import styled, { css } from 'styled-components';
import { pxToRem } from '../../../foundation/spacing/utils.js';
import { themeGet } from '../../../foundation/theme/themeGet/get.js';
import { TableRow } from '../TableRow/TableRow.js';

var Container = styled.div.withConfig({
  displayName: "Container",
  componentId: "sc-18t6m4q-0"
})(["position:relative;max-width:100%;overflow-x:auto;height:", ";box-sizing:border-box;", ";"], function (_ref) {
  var $maxHeight = _ref.$maxHeight;
  return $maxHeight && $maxHeight;
}, function (_ref2) {
  var _ref2$$border = _ref2.$border,
    $border = _ref2$$border === void 0 ? false : _ref2$$border;
  return $border && css(["border:solid ", " ", ";"], pxToRem(1), themeGet('colors.border.100'));
});
var StyledTable = styled.table.withConfig({
  displayName: "StyledTable",
  componentId: "sc-18t6m4q-1"
})(["width:100%;position:relative;border-spacing:0;z-index:0;background-color:", ";& ", "{height:", ";}"], themeGet('colors.background.50'), TableRow, function (p) {
  return p.$dense ? pxToRem(40) : pxToRem(48);
});

export { Container, StyledTable };
